module.exports = __webpack_public_path__ + "img/drug-cat(old).be8141b0.png";